module.exports = __webpack_public_path__ + "static/media/bike2a.3573bc07.jpg";